var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.show_header)?_c('SGHeader'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"min-height":"500px"}},[_c('router-view')],1),_vm._v(" "),(_vm.show_footer)?_c('div',{staticClass:"sg-round-bottom-base"},[_c('div',{staticClass:"sg-round-bottom"})]):_vm._e(),_vm._v(" "),(_vm.show_footer)?_c('SGFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b981e65","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 